import React, { Component } from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  CssBaseline, Container, Typography, Box, Button, Chip, Tooltip, IconButton, Dialog, DialogTitle, DialogContent, DialogActions,
  Tabs, Tab, TextField, Skeleton, Menu, MenuItem, ListItemIcon, Table, TableHead, TableBody, TableRow, TableCell, CircularProgress, Alert,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { Styles } from '../../styles/material-styles';
import { Overlay } from '../../styles/global';
import HeaderMenu from '../../components/header-menu';
import Footer from '../../components/footer';
import CustomizedSnackbars from '../../components/material-snackbars';
import SimpleAutoComplete from '../../components/auto-complete/autocomplete';
import { injectIntl } from 'react-intl';
import * as componentActions from '../../redux/actions/header-menu';
import ScheduleSendOutlinedIcon from '@mui/icons-material/ScheduleSendOutlined';
import HistoryIcon from '@mui/icons-material/History';
import RefreshIcon from '@mui/icons-material/Refresh';
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SwapHorizOutlinedIcon from '@mui/icons-material/SwapHorizOutlined';
import DomainVerificationOutlinedIcon from '@mui/icons-material/DomainVerificationOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AddIcon from '@mui/icons-material/Add';
import ScheduleReportDialog from '../../components/report-schedule/schedule-report-dialog';
import RunDetailsDialog from '../../components/report-schedule/run-details-dialog';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import DetailsDialog, { buildMemberRows, buildMembersFooter, ELIGIBILITY_BADGE } from '../../components/report-schedule/details-dialog';
import { buildScheduleSummary } from '../../components/report-schedule/recurrence-editor';
import ReportScheduleService, { getCatalogEntry } from '../../services/report-schedule.service';

const STATUS_STYLE = {
  active: { bg: '#eef7e3', color: '#5b9b1e' },
  paused: { bg: '#f1f1f1', color: '#777' },
  paused_by_system: { bg: '#fff4e5', color: '#b9770e' },
};
const RUN_STATUS_STYLE = {
  queued: { bg: '#e8f1ff', color: '#277afe' },
  processing: { bg: '#e8f1ff', color: '#277afe' },
  delivered: { bg: '#eef7e3', color: '#5b9b1e' },
  failed: { bg: '#fdecea', color: '#c62828' },
  skipped_empty: { bg: '#f1f1f1', color: '#777' },
};
const greenBtn = { textTransform: 'none', backgroundColor: '#8BC34A', '&:hover': { backgroundColor: '#7cb342' } };
const DOMAIN_REGEX = /^[a-z0-9-]+(\.[a-z0-9-]+)+$/;

class ReportSchedules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      actionLoading: false,
      tab: 'mine',
      schedules: [],
      notification: { open: false, variant: 'success', message: '' },
      menuAnchor: null, menuItem: null,
      editItem: null, editKey: 0,
      historyItem: null, runs: [], loadingRuns: false,
      runDetailId: null,
      deleteItem: null,
      transferItem: null, transferUser: { id: 0, name: '' }, users: [], usersLoading: false, usersLoaded: false,
      domainsOpen: false, domains: [], domainInput: '', domainError: '',
      details: null,
    };
  }

  componentDidMount() {
    this.load();
  }

  get currentUser() {
    const u = (this.props.userSession && this.props.userSession.user) || {};
    return { id: u.id, name: u.name, email: u.email };
  }

  get userRoles() { const u = this.props.userSession; return (u && u.user && Array.isArray(u.user.userrole)) ? u.user.userrole : []; }
  isAdmin = () => this.userRoles.some(ur => ur && ur.role && [0, 1, 4].includes(Number(ur.role.roletype)));

  notify = (message, variant = 'success') => this.setState({ notification: { open: true, variant, message } });
  errorOf = (err) => err?.response?.data?.errors?.[0] || this.props.intl.formatMessage({ id: 'report.schedule.toast.error' });

  load(tab = this.state.tab) {
    this.setState({ loading: true });
    ReportScheduleService.list(tab, this.currentUser)
      .then(result => {
        this.setState({ loading: false, schedules: (result.data && result.data.success) ? result.data.data : [] });
      })
      .catch(err => { this.setState({ loading: false }); this.notify(this.errorOf(err), 'error'); });
  }

  // Executa uma ação de linha com overlay e recarrega a lista.
  runAction(promise, successId, values) {
    this.setState({ actionLoading: true, menuAnchor: null });
    return promise
      .then(() => {
        this.setState({ actionLoading: false });
        if (successId) this.notify(this.props.intl.formatMessage({ id: successId }, values));
        this.load();
      })
      .catch(err => { this.setState({ actionLoading: false }); this.notify(this.errorOf(err), 'error'); });
  }

  changeTab = (e, tab) => { this.setState({ tab }); this.load(tab); };
  openMenu = (e, item) => this.setState({ menuAnchor: e.currentTarget, menuItem: item });
  closeMenu = () => this.setState({ menuAnchor: null });

  toggleStatus = (s) => {
    const next = s.status === 'active' ? 'paused' : 'active';
    this.runAction(ReportScheduleService.setStatus(s.id, next), next === 'active' ? 'report.schedule.toast.resumed' : 'report.schedule.toast.paused');
  };
  // Executa agora e já abre o detalhe da execução (acompanha ao vivo).
  runNow = (s) => {
    this.setState({ actionLoading: true, menuAnchor: null });
    ReportScheduleService.runNow(s.id, 'manual')
      .then((result) => {
        const data = result && result.data ? result.data.data : null;
        const runId = data ? (data.runid ?? data.runId) : null;
        this.setState({ actionLoading: false, runDetailId: runId || null });
        this.notify(this.props.intl.formatMessage({ id: 'report.schedule.toast.runQueued' }));
        this.load();
      })
      .catch(err => { this.setState({ actionLoading: false }); this.notify(this.errorOf(err), 'error'); });
  };
  duplicate = (s) => this.runAction(ReportScheduleService.duplicate(s.id, this.props.intl.formatMessage({ id: 'report.schedule.copySuffix' })), 'report.schedule.toast.duplicated');
  confirmDelete = () => {
    const s = this.state.deleteItem;
    this.setState({ deleteItem: null });
    this.runAction(ReportScheduleService.remove(s.id), 'report.schedule.toast.deleted');
  };

  openEdit = (s) => this.setState(p => ({ editItem: s, editKey: p.editKey + 1, menuAnchor: null }));
  editSaved = () => { this.setState({ editItem: null }); this.notify(this.props.intl.formatMessage({ id: 'report.schedule.toast.updated' })); this.load(); };

  // ----- modais de detalhe (destinatários → membros) -----
  closeDetails = () => this.setState({ details: null });
  patchDetails = (p) => this.setState(prev => (prev.details ? { details: { ...prev.details, ...p } } : null));

  openMembers = (r) => {
    const { intl } = this.props;
    this.setState({ details: { title: r.name, subtitle: intl.formatMessage({ id: `report.schedule.recipientType.${r.type}` }), loading: true, rows: [], searchable: true } });
    ReportScheduleService.getRecipientMembers(r.type, r.id)
      .then(res => {
        const members = (res.data && res.data.data) || [];
        this.patchDetails({ loading: false, rows: buildMemberRows(intl, members), footer: buildMembersFooter(intl, members) });
      })
      .catch(err => { this.setState({ details: null }); this.notify(this.errorOf(err), 'error'); });
  };

  openRecipients = (s) => {
    const { intl } = this.props;
    const rows = [];
    if (s.includeOwner) rows.push({ key: 'owner', primary: s.ownerName || '—', chips: [intl.formatMessage({ id: 'report.schedule.recipientType.owner' })] });
    s.recipients.forEach((r, i) => {
      const dynamic = ['team', 'role', 'marketing_list'].includes(r.type);
      rows.push({
        key: `${r.type}-${r.id || r.name}-${i}`, primary: r.name,
        secondary: dynamic ? intl.formatMessage({ id: 'report.schedule.details.clickMembers' }) : null,
        chips: [intl.formatMessage({ id: `report.schedule.recipientType.${r.type}` })],
        onClick: dynamic ? () => this.openMembers(r) : undefined,
      });
    });
    this.setState({ details: { title: intl.formatMessage({ id: 'report.schedule.review.recipients' }), subtitle: s.name, loading: false, rows } });
  };

  // Destinatários descartados num envio (sem e-mail / domínio fora da lista permitida).
  openDiscarded = (run) => {
    const { intl } = this.props;
    this.setState({
      details: {
        title: intl.formatMessage({ id: 'report.schedule.history.discardedTitle' }),
        subtitle: `#${run.runNumber} · ${this.fmtDate(run.scheduledFor)}`,
        loading: false,
        searchable: true,
        rows: run.discarded.map((d, i) => ({
          key: `${d.target}-${i}`,
          primary: d.target,
          badge: { ...(ELIGIBILITY_BADGE[d.reason] || ELIGIBILITY_BADGE.no_email), label: intl.formatMessage({ id: `report.schedule.eligibility.${d.reason}` }) },
        })),
        footer: intl.formatMessage({ id: 'report.schedule.history.discardedFooter' }),
      },
    });
  };

  // Envios de teste não pertencem a um agendamento: lista própria (só os do usuário).
  openTestHistory = () => {
    this.setState({ historyItem: { isTest: true, name: this.props.intl.formatMessage({ id: 'report.schedule.tests.subtitle' }) }, runs: [], loadingRuns: true });
    ReportScheduleService.getTestRuns()
      .then(result => this.setState({ loadingRuns: false, runs: (result.data && result.data.success) ? result.data.data : [] }))
      .catch(err => { this.setState({ loadingRuns: false }); this.notify(this.errorOf(err), 'error'); });
  };

  openRunDetail = (run) => this.setState({ runDetailId: run.id });

  openHistory = (s) => {
    this.setState({ historyItem: s, runs: [], loadingRuns: true });
    ReportScheduleService.getRuns(s.id)
      .then(result => this.setState({ loadingRuns: false, runs: (result.data && result.data.success) ? result.data.data : [] }))
      .catch(err => { this.setState({ loadingRuns: false }); this.notify(this.errorOf(err), 'error'); });
  };

  openTransfer = (s) => {
    this.setState({ transferItem: s, transferUser: { id: 0, name: '' }, menuAnchor: null });
    if (this.state.usersLoaded || this.state.usersLoading) return;
    this.setState({ usersLoading: true });
    ReportScheduleService.getRecipientSources()
      .then(r => {
        const ok = r.data && r.data.success;
        this.setState({ usersLoading: false, usersLoaded: !!ok, users: ok ? (r.data.data.users || []) : [] });
      })
      .catch(err => { this.setState({ usersLoading: false }); this.notify(this.errorOf(err), 'error'); });
  };
  confirmTransfer = () => {
    const { transferItem, transferUser } = this.state;
    this.setState({ transferItem: null });
    this.runAction(ReportScheduleService.transferOwner(transferItem.id, transferUser), 'report.schedule.toast.transferred', { name: transferUser.name });
  };

  openDomains = () => {
    this.setState({ domainsOpen: true, domainInput: '', domainError: '' });
    ReportScheduleService.getAllowedDomains().then(r => this.setState({ domains: (r.data && r.data.success) ? r.data.data : [] }));
  };
  addDomain = () => {
    const d = this.state.domainInput.trim().toLowerCase().replace(/^@/, '');
    if (!DOMAIN_REGEX.test(d)) { this.setState({ domainError: this.props.intl.formatMessage({ id: 'report.schedule.domains.invalid' }) }); return; }
    if (this.state.domains.includes(d)) { this.setState({ domainInput: '' }); return; }
    this.setState(p => ({ domains: [...p.domains, d], domainInput: '', domainError: '' }));
  };
  saveDomains = () => {
    this.setState({ domainsOpen: false });
    this.runAction(ReportScheduleService.saveAllowedDomains(this.state.domains), 'report.schedule.toast.domainsSaved');
  };

  fmtDate = (d) => (d ? moment(d).format('DD/MM/YYYY HH:mm') : '—');

  statusChip(s) {
    const { intl } = this.props;
    const st = STATUS_STYLE[s.status] || STATUS_STYLE.paused;
    const chip = <Chip size="small" label={intl.formatMessage({ id: `report.schedule.status.${s.status}` })} icon={s.status === 'paused_by_system' ? <WarningAmberIcon /> : undefined}
      sx={{ backgroundColor: st.bg, color: st.color, fontWeight: 600, '& .MuiChip-icon': { color: st.color } }} />;
    return s.status === 'paused_by_system' && s.statusReason
      ? <Tooltip title={intl.formatMessage({ id: `report.schedule.reason.${s.statusReason}` })}>{chip}</Tooltip>
      : chip;
  }

  runStatusChip(status, onClick) {
    const { intl } = this.props;
    if (!status) return <Typography sx={{ fontSize: 13, color: '#aaa' }}>—</Typography>;
    const st = RUN_STATUS_STYLE[status] || RUN_STATUS_STYLE.queued;
    const chip = <Chip size="small" label={intl.formatMessage({ id: `report.schedule.run.status.${status}` })}
      clickable={!!onClick} onClick={onClick ? e => { e.stopPropagation(); onClick(); } : undefined}
      sx={{ backgroundColor: st.bg, color: st.color, fontWeight: 600, '&:hover': onClick ? { backgroundColor: st.bg, filter: 'brightness(0.95)' } : undefined }} />;
    return onClick ? <Tooltip title={intl.formatMessage({ id: 'report.schedule.action.history' })}>{chip}</Tooltip> : chip;
  }

  renderEmpty() {
    const { intl } = this.props;
    const lang = this.props.match.params.lang;
    return (
      <Box sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{ width: 72, height: 72, borderRadius: '50%', backgroundColor: '#f5f5f5', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
          <ScheduleSendOutlinedIcon sx={{ fontSize: 36, color: '#bdbdbd' }} />
        </Box>
        <Typography sx={{ fontSize: 18, fontWeight: 600, color: '#555', mb: 0.5 }}>{intl.formatMessage({ id: 'report.schedule.empty.title' })}</Typography>
        <Typography sx={{ fontSize: 14, color: '#888', mb: 2, maxWidth: 460, mx: 'auto' }}>{intl.formatMessage({ id: 'report.schedule.empty.desc' })}</Typography>
        <Button variant="contained" startIcon={<AssessmentOutlinedIcon />} onClick={() => this.props.history.push(`/${lang}/calledreports`)} sx={greenBtn}>
          {intl.formatMessage({ id: 'report.schedule.empty.action' })}
        </Button>
      </Box>
    );
  }

  renderSkeleton() {
    return (
      <Box sx={{ p: 2 }}>
        {[1, 2, 3, 4].map(i => <Skeleton key={i} variant="rounded" height={52} animation="wave" sx={{ mb: 1 }} />)}
      </Box>
    );
  }

  renderTable() {
    const { intl } = this.props;
    const { schedules, tab } = this.state;
    const head = { fontSize: 12, fontWeight: 700, color: '#777', textTransform: 'uppercase', letterSpacing: 0.3 };
    return (
      <Box sx={{ overflowX: 'auto' }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.name' })}</TableCell>
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.when' })}</TableCell>
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.recipients' })}</TableCell>
              {tab === 'all' && <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.owner' })}</TableCell>}
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.next' })}</TableCell>
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.last' })}</TableCell>
              <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.status' })}</TableCell>
              <TableCell sx={head} align="right">{intl.formatMessage({ id: 'report.schedule.col.actions' })}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schedules.map(s => {
              const entry = getCatalogEntry(s.reportKey);
              const recipientsTotal = s.recipients.length + (s.includeOwner ? 1 : 0);
              const recipientsTip = [s.includeOwner ? s.ownerName : null, ...s.recipients.map(r => r.name)].filter(Boolean).join(', ');
              return (
                <TableRow key={s.id} hover onClick={() => (s.lastRunStatus ? this.openHistory(s) : this.openEdit(s))}
                  sx={{ cursor: 'pointer', borderLeft: s.status === 'active' ? '4px solid #8BC34A' : '4px solid transparent' }}>
                  <TableCell>
                    <Typography sx={{ fontSize: 14, fontWeight: 600, color: '#333' }}>{s.name}</Typography>
                    <Typography sx={{ fontSize: 12, color: '#888' }}>
                      {entry ? intl.formatMessage({ id: entry.labelId }) : s.reportKey} · {s.format.toUpperCase()}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ fontSize: 13, color: '#555', maxWidth: 260 }}>{buildScheduleSummary(intl, s)}</TableCell>
                  <TableCell>
                    <Tooltip title={recipientsTip || '—'}>
                      <Chip size="small" variant="outlined" clickable label={intl.formatMessage({ id: 'report.schedule.recipients.total' }, { n: recipientsTotal })}
                        onClick={e => { e.stopPropagation(); this.openRecipients(s); }} />
                    </Tooltip>
                  </TableCell>
                  {tab === 'all' && <TableCell sx={{ fontSize: 13 }}>{s.ownerName}</TableCell>}
                  <TableCell sx={{ fontSize: 13, whiteSpace: 'nowrap' }}>{this.fmtDate(s.nextRunAt)}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, alignItems: 'flex-start' }}>
                      {this.runStatusChip(s.lastRunStatus, () => this.openHistory(s))}
                      {s.lastRunAt && <Typography sx={{ fontSize: 11, color: '#999' }}>{this.fmtDate(s.lastRunAt)}</Typography>}
                    </Box>
                  </TableCell>
                  <TableCell>{this.statusChip(s)}</TableCell>
                  <TableCell align="right" sx={{ whiteSpace: 'nowrap' }} onClick={e => e.stopPropagation()}>
                    <Tooltip title={intl.formatMessage({ id: 'report.schedule.action.history' })}>
                      <IconButton size="small" onClick={() => this.openHistory(s)}><HistoryIcon fontSize="small" /></IconButton>
                    </Tooltip>
                    <Tooltip title={intl.formatMessage({ id: 'report.schedule.action.runNow' })}>
                      <span><IconButton size="small" disabled={s.status === 'paused_by_system'} onClick={() => this.runNow(s)}><PlayArrowOutlinedIcon fontSize="small" /></IconButton></span>
                    </Tooltip>
                    <Tooltip title={intl.formatMessage({ id: s.status === 'active' ? 'report.schedule.action.pause' : 'report.schedule.action.resume' })}>
                      <IconButton size="small" onClick={() => this.toggleStatus(s)}>
                        {s.status === 'active' ? <PauseCircleOutlineIcon fontSize="small" /> : <PlayCircleOutlineIcon fontSize="small" />}
                      </IconButton>
                    </Tooltip>
                    <IconButton size="small" onClick={e => this.openMenu(e, s)}><MoreVertIcon fontSize="small" /></IconButton>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    );
  }

  renderHistoryDialog() {
    const { intl } = this.props;
    const { historyItem, runs, loadingRuns } = this.state;
    if (!historyItem) return null;
    const head = { fontSize: 12, fontWeight: 700, color: '#777' };
    return (
      <Dialog open onClose={() => this.setState({ historyItem: null })} maxWidth="md" fullWidth PaperProps={{ sx: { maxHeight: '90vh', borderRadius: 3 } }}>
        <DialogTitle>
          <Typography sx={{ fontSize: 18, fontWeight: 700 }}>{intl.formatMessage({ id: historyItem.isTest ? 'report.schedule.tests.title' : 'report.schedule.history.title' })}</Typography>
          <Typography sx={{ fontSize: 13, color: '#888' }}>{historyItem.name}</Typography>
          {runs.length > 0 && <Typography sx={{ fontSize: 12, color: '#277afe', mt: 0.5 }}>{intl.formatMessage({ id: 'report.schedule.history.clickHint' })}</Typography>}
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '16px 20px' }}>
            {loadingRuns ? [1, 2, 3].map(i => <Skeleton key={i} variant="rounded" height={40} animation="wave" sx={{ mb: 1 }} />)
              : runs.length === 0 ? (
                <Typography sx={{ fontSize: 14, color: '#888', textAlign: 'center', py: 4 }}>{intl.formatMessage({ id: historyItem.isTest ? 'report.schedule.tests.empty' : 'report.schedule.history.empty' })}</Typography>
              ) : (
                <Box sx={{ overflowX: 'auto' }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell sx={head}>{historyItem.isTest ? intl.formatMessage({ id: 'report.schedule.col.name' }) : '#'}</TableCell>
                        <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.history.when' })}</TableCell>
                        <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.history.trigger' })}</TableCell>
                        <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.col.status' })}</TableCell>
                        <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.history.rows' })}</TableCell>
                        <TableCell sx={head}>{intl.formatMessage({ id: 'report.schedule.history.delivery' })}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {runs.map(r => (
                        <TableRow key={r.id} hover onClick={() => this.openRunDetail(r)} sx={{ cursor: 'pointer' }}>
                          <TableCell sx={{ fontSize: 13 }}>{historyItem.isTest ? (r.name || '—') : r.runNumber}</TableCell>
                          <TableCell sx={{ fontSize: 13, whiteSpace: 'nowrap' }}>{this.fmtDate(r.scheduledFor)}</TableCell>
                          <TableCell sx={{ fontSize: 13 }}>{intl.formatMessage({ id: `report.schedule.trigger.${r.triggeredBy}` })}</TableCell>
                          <TableCell>
                            {this.runStatusChip(r.status)}
                            {r.error && (
                              <Tooltip title={r.error}>
                                <Typography sx={{ fontSize: 11, color: r.status === 'failed' ? '#c62828' : '#b9770e', mt: 0.5, maxWidth: 260, overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
                                  {r.error}
                                </Typography>
                              </Tooltip>
                            )}
                          </TableCell>
                          <TableCell sx={{ fontSize: 13 }}>{r.status === 'queued' ? '—' : r.rowCount}</TableCell>
                          <TableCell sx={{ fontSize: 13 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.4 }}>
                              <span>
                                {r.status === 'delivered'
                                  ? intl.formatMessage({ id: `report.schedule.delivery.kind.${r.delivery}` }, { n: r.recipientsCount })
                                  : '—'}
                              </span>
                              {r.discarded.length > 0 && (
                                <Chip size="small" clickable onClick={(e) => { e.stopPropagation(); this.openDiscarded(r); }}
                                  icon={<WarningAmberIcon />}
                                  label={intl.formatMessage({ id: 'report.schedule.history.discarded' }, { n: r.discarded.length })}
                                  sx={{ backgroundColor: '#fff4e5', color: '#b9770e', fontWeight: 600, '& .MuiChip-icon': { color: '#b9770e' } }} />
                              )}
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
              )}
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ historyItem: null })} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'report.schedule.close' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDeleteDialog() {
    const { intl } = this.props;
    const { deleteItem } = this.state;
    if (!deleteItem) return null;
    return (
      <Dialog open onClose={() => this.setState({ deleteItem: null })} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>{intl.formatMessage({ id: 'report.schedule.delete.title' })}</DialogTitle>
        <DialogContent>
          <Typography sx={{ fontSize: 14, color: '#555' }}>{intl.formatMessage({ id: 'report.schedule.delete.desc' }, { name: deleteItem.name })}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ deleteItem: null })} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button variant="contained" color="error" onClick={this.confirmDelete} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'delete' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderTransferDialog() {
    const { intl } = this.props;
    const { transferItem, transferUser, users, usersLoading } = this.state;
    if (!transferItem) return null;
    return (
      <Dialog open onClose={() => this.setState({ transferItem: null })} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>{intl.formatMessage({ id: 'report.schedule.transfer.title' })}</DialogTitle>
        <DialogContent dividers>
          <Typography sx={{ fontSize: 14, color: '#555', mb: 2 }}>{intl.formatMessage({ id: 'report.schedule.transfer.desc' }, { name: transferItem.name, owner: transferItem.ownerName })}</Typography>
          {usersLoading
            ? <Skeleton variant="rounded" height={56} animation="wave" />
            : <SimpleAutoComplete label={intl.formatMessage({ id: 'report.schedule.transfer.newOwner' })} options={users} stateName="owner"
              selected={transferUser} changeSelect={(n, v) => this.setState({ transferUser: v || { id: 0, name: '' } })} />}
          <Alert severity="info" sx={{ mt: 2 }}>{intl.formatMessage({ id: 'report.schedule.transfer.scopeNotice' })}</Alert>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ transferItem: null })} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button variant="contained" disabled={usersLoading || !transferUser || !transferUser.id} onClick={this.confirmTransfer} sx={greenBtn}>
            {intl.formatMessage({ id: 'report.schedule.transfer.confirm' })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderDomainsDialog() {
    const { intl } = this.props;
    const { domainsOpen, domains, domainInput, domainError } = this.state;
    if (!domainsOpen) return null;
    return (
      <Dialog open onClose={() => this.setState({ domainsOpen: false })} maxWidth="sm" fullWidth PaperProps={{ sx: { maxHeight: '90vh', borderRadius: 3 } }}>
        <DialogTitle sx={{ fontSize: 18, fontWeight: 700 }}>{intl.formatMessage({ id: 'report.schedule.domains.title' })}</DialogTitle>
        <DialogContent dividers sx={{ p: 0 }}>
          <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '16px 20px' }}>
            <Typography sx={{ fontSize: 13, color: '#666', mb: 2 }}>{intl.formatMessage({ id: 'report.schedule.domains.desc' })}</Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
              <TextField fullWidth size="small" InputLabelProps={{ shrink: true }} placeholder="empresa.com.br"
                label={intl.formatMessage({ id: 'report.schedule.domains.input' })} value={domainInput} error={!!domainError} helperText={domainError || ' '}
                onChange={e => this.setState({ domainInput: e.target.value, domainError: '' })}
                onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); this.addDomain(); } }} />
              <Button variant="outlined" startIcon={<AddIcon />} onClick={this.addDomain} sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444', height: 40 }}>
                {intl.formatMessage({ id: 'report.schedule.recipients.add' })}
              </Button>
            </Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8 }}>
              {domains.length === 0
                ? <Typography sx={{ fontSize: 13, color: '#999' }}>{intl.formatMessage({ id: 'report.schedule.domains.none' })}</Typography>
                : domains.map(d => <Chip key={d} label={`@${d}`} onDelete={() => this.setState(p => ({ domains: p.domains.filter(x => x !== d) }))} />)}
            </Box>
            <Alert severity="warning" sx={{ mt: 2 }}>{intl.formatMessage({ id: 'report.schedule.domains.notice' })}</Alert>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => this.setState({ domainsOpen: false })} sx={{ textTransform: 'none' }}>{intl.formatMessage({ id: 'cancel' })}</Button>
          <Button variant="contained" onClick={this.saveDomains} sx={greenBtn}>{intl.formatMessage({ id: 'save' })}</Button>
        </DialogActions>
      </Dialog>
    );
  }

  render() {
    const { classes, headerMenu, actionsHeaderMenu, intl } = this.props;
    const { loading, actionLoading, tab, schedules, notification, menuAnchor, menuItem, editItem, editKey } = this.state;
    const admin = this.isAdmin();

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open }, classes.actionsContent, { [classes.actionscontentShift]: actionsHeaderMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='xl' style={{ maxWidth: '100%', paddingLeft: 0, marginLeft: 0 }}>
            <CssBaseline />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
              <ScheduleSendOutlinedIcon sx={{ color: '#8BC34A', fontSize: 28 }} />
              <Box sx={{ flex: 1, minWidth: 220 }}>
                <Typography sx={{ fontSize: 20, fontWeight: 700, color: '#333' }}>{intl.formatMessage({ id: 'report.schedule.page.title' })}</Typography>
                <Typography sx={{ fontSize: 13, color: '#888' }}>{intl.formatMessage({ id: 'report.schedule.page.subtitle' })}</Typography>
              </Box>
              <Tooltip title={intl.formatMessage({ id: 'report.schedule.page.refresh' })}>
                <span>
                  <IconButton onClick={() => this.load()} disabled={loading}
                    sx={{ border: '1px solid #cfcfcf', borderRadius: '8px', color: '#8BC34A', width: 40, height: 40, '&:hover': { backgroundColor: '#f1f8e9', borderColor: '#8BC34A' } }}>
                    {loading ? <CircularProgress size={18} sx={{ color: '#8BC34A' }} /> : <RefreshIcon fontSize="small" />}
                  </IconButton>
                </span>
              </Tooltip>
              <Button variant="outlined" startIcon={<ScienceOutlinedIcon />} onClick={this.openTestHistory}
                sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
                {intl.formatMessage({ id: 'report.schedule.tests.button' })}
              </Button>
              {admin && (
                <Button variant="outlined" startIcon={<DomainVerificationOutlinedIcon />} onClick={this.openDomains}
                  sx={{ textTransform: 'none', borderColor: '#cfcfcf', color: '#444' }}>
                  {intl.formatMessage({ id: 'report.schedule.domains.title' })}
                </Button>
              )}
            </Box>

            <Box sx={{ border: '1px solid #e0e0e0', borderRadius: '12px', backgroundColor: '#fff' }}>
              <Tabs value={tab} onChange={this.changeTab} sx={{ px: 2, borderBottom: '1px solid #eee', '& .Mui-selected': { color: '#5b9b1e !important' }, '& .MuiTabs-indicator': { backgroundColor: '#8BC34A' } }}>
                <Tab value="mine" label={intl.formatMessage({ id: 'report.schedule.tab.mine' })} sx={{ textTransform: 'none' }} />
                {admin && <Tab value="all" label={intl.formatMessage({ id: 'report.schedule.tab.all' })} sx={{ textTransform: 'none' }} />}
              </Tabs>
              {loading ? this.renderSkeleton() : schedules.length === 0 ? this.renderEmpty() : this.renderTable()}
            </Box>
          </Container>
          <Footer />
        </main>

        <Menu anchorEl={menuAnchor} open={!!menuAnchor} onClose={this.closeMenu}>
          <MenuItem onClick={() => this.openEdit(menuItem)}>
            <ListItemIcon><EditOutlinedIcon fontSize="small" /></ListItemIcon>{intl.formatMessage({ id: 'edit' })}
          </MenuItem>
          <MenuItem onClick={() => this.duplicate(menuItem)}>
            <ListItemIcon><ContentCopyOutlinedIcon fontSize="small" /></ListItemIcon>{intl.formatMessage({ id: 'report.schedule.action.duplicate' })}
          </MenuItem>
          {admin && (
            <MenuItem onClick={() => this.openTransfer(menuItem)}>
              <ListItemIcon><SwapHorizOutlinedIcon fontSize="small" /></ListItemIcon>{intl.formatMessage({ id: 'report.schedule.action.transfer' })}
            </MenuItem>
          )}
          <MenuItem onClick={() => this.setState({ deleteItem: menuItem, menuAnchor: null })} sx={{ color: '#c62828' }}>
            <ListItemIcon><DeleteOutlineIcon fontSize="small" sx={{ color: '#c62828' }} /></ListItemIcon>{intl.formatMessage({ id: 'delete' })}
          </MenuItem>
        </Menu>

        {editItem && (
          <ScheduleReportDialog key={editKey} open schedule={editItem} currentUser={this.currentUser}
            onClose={() => this.setState({ editItem: null })} onSaved={this.editSaved} />
        )}
        {this.renderHistoryDialog()}
        {this.state.runDetailId && (
          <RunDetailsDialog key={this.state.runDetailId} open runId={this.state.runDetailId} onClose={() => this.setState({ runDetailId: null })} />
        )}
        {this.state.details && (
          <DetailsDialog key={`${this.state.details.title}-${this.state.details.subtitle}`} open onClose={this.closeDetails} {...this.state.details} />
        )}
        {this.renderDeleteDialog()}
        {this.renderTransferDialog()}
        {this.renderDomainsDialog()}

        {actionLoading && (
          <Overlay>
            <CircularProgress color='secondary' />
          </Overlay>
        )}
        <CustomizedSnackbars variant={notification.variant} message={notification.message} isOpen={notification.open}
          toClose={() => this.setState({ notification: { ...notification, open: false } })} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  actionsHeaderMenu: state.actionsHeaderMenu,
  headerMenu: state.headerMenu,
  userSession: state.userSession,
});
const mapDispatchToProps = dispatch => bindActionCreators(componentActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ReportSchedules)));
